<template>
  <a :href="base + to" @click="goto" class="vklink-a"><slot/></a>
</template>

<script>

export default {

  props: {
    to: {
      type: String
    },
    type: {
      type: String,
      default: 'h5'
    },
    base: {
      type: String,
      default: '/web'
    },
    options: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {

    }
  },
  watch: {

  },
  mounted () {
  },
  methods: {
    goto(e) {
      if (!this.disabled) {
        this.$pushRoute(this.to, this.type, this.options)
      }
      e.preventDefault()
      return false
    }
  },
  components: {

  }
}

</script>

<style lang="less" scoped>

  .vklink-a {
    text-decoration: none;

    &:link, &:visited, &:active, &:hover {
      text-decoration: none;
    }
  }

</style>
